import React, { useContext } from "react";
import { useQuery, useMutation } from "@apollo/client";
import { Header, Loader, Form } from "semantic-ui-react";
import { GET_PROFILE, INVITE_USER, REMOVE_ASSISTANT } from "../../GraphQL";
import SimpleUserList from "components/SimpleUserList";
import UserContext from "contexts/UserContext";
import gql from "graphql-tag";

const AssistantSettings = () => {
  const appUser = useContext(UserContext);
  const { loading, error, data } = useQuery(GET_PROFILE);
  const [inviteUser, { error: inviteError }] = useMutation(INVITE_USER);
  const [removeAssistant] = useMutation(REMOVE_ASSISTANT);

  if (loading) {
    return <Loader active />;
  } else if (error) {
    throw error;
  }
  console.log(appUser);
  console.log(data);
  const myProfile = data.myProfile;

  return (
    <div>
      <Header as="h3">
        My Support Staff
        <Header.Subheader>
          Staff members can view all students and their reports in your class.
          They can help you create and edit reports, but cannot send them to
          parents.
        </Header.Subheader>
      </Header>
      <Form>
        <SimpleUserList
          users={myProfile.assistants}
          error={inviteError}
          onRemoveUser={(user, index) =>
            removeAssistant({
              variables: { assistant: user.sub },
              update: (cache, { data: { removeAssistant } }) => {
                cache.modify({
                  id: cache.identify(myProfile),
                  fields: {
                    assistants(existingAssistants = [], { readField }) {
                      return existingAssistants.filter(
                        (r) => readField("sub", r) !== user.sub
                      );
                    },
                  },
                });
              },
            })
          }
          onAddUser={(email) =>
            inviteUser({
              variables: { group: "Assistants", id: appUser.id, email },
              update: (cache, { data: { inviteUser } }) => {
                cache.modify({
                  id: cache.identify(myProfile),
                  fields: {
                    assistants(existingAssistants = [], { readField }) {
                      const newUserRef = cache.writeFragment({
                        data: inviteUser,
                        fragment: gql`
                          fragment NewUser on User {
                            email
                            status
                            sub
                          }
                        `,
                      });

                      return [...existingAssistants, newUserRef];
                    },
                  },
                });
              },
            })
          }
        />
      </Form>
    </div>
  );
};

export default AssistantSettings;
